import "./index.css";
import React from "react";
import { withRouter } from "react-router-dom";
import AuthTokenHolder from "@/services/http/AuthTokenHolder";

function getWechatIframeUrl() {
  const search = new URLSearchParams();

  search.set("redirect_uri", "https://main.fahuoyi.com/wechat/login");
  search.set("appid", "wxb4e0d35c482273be");
  search.set("response_type", "code");
  search.set("scope", "snsapi_login");
  search.set("connect_redirect", "1");
  search.set("state", "ES_");
  search.set("style", "black");

  return `https://open.weixin.qq.com/connect/qrconnect?${search.toString()}#wechat_redirect`;
}

class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    // 已经有token时候，校验当前token是否可用，可用则跳转主页
    const token = AuthTokenHolder.getToken();
    const isAuthenticated = token && token !== "null";
    if (isAuthenticated) {
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <div id={"wechatLoginQrCodeContainer"} className={"loginWrapper"}>
        <div id={"loginContent"}>
          <div className={"inlineBlock fw700 fs24"}>
            <img id={"logo"} />
            发货易电子面单共享平台
          </div>
          <p className={"loginTitle fs14 fw400"}>发货易 — 多平台电商打单发货软件</p>
          <div id={"login_container"}>
            <iframe
              src={getWechatIframeUrl()}
              scrolling="no"
              width="300px"
              height="400px"
              style={{ border: 0 }}
              sandbox="allow-scripts allow-popups allow-top-navigation allow-top-navigation-by-user-activation allow-same-origin"
            ></iframe>
          </div>
        </div>

        <div id={"footer"}>
          copyright©2020 广州锐微信息科技有限公司
          <a target="_blank" href="http://www.beian.miit.gov.cn">
            粤ICP备16011801号
          </a>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
